import { StarIcon } from "@heroicons/react/24/outline";

import { DropdownMenuItem } from "@fronterahealth/frontera-ui-components/ui/dropdown-menu";

import { ReportReviewerKind, ReportReviewerStatus } from "@api/graphql/types-and-hooks";
import { useCanRequestReview, useCanSetFinalReviewer } from "@components/ReportReview/hooks/useCanManageReview";
import { useReviewRequest } from "@components/ReportReview/hooks/useReviewRequest";
import { Reviewer } from "@components/ReportReview/reviewers";

export const FinalApproverMenuItem: React.FC<{ reviewer: Reviewer }> = ({ reviewer }) => {
  const { request } = useReviewRequest();
  const canRequestReview = useCanRequestReview();
  const canSetFinalApprover = useCanSetFinalReviewer();
  const isPending = reviewer.status === ReportReviewerStatus.Requested;

  if (reviewer.type === ReportReviewerKind.FinalApprover) {
    return (
      <DropdownMenuItem
        disabled={!canRequestReview || !isPending}
        onClick={() =>
          reviewer.reviewer && request([{ userId: reviewer.reviewer.id, type: ReportReviewerKind.Reviewer }])
        }
      >
        <StarIcon />
        Set as Reviewer
      </DropdownMenuItem>
    );
  }

  return (
    <DropdownMenuItem
      disabled={!canSetFinalApprover || !isPending}
      onClick={() =>
        reviewer.reviewer && request([{ userId: reviewer.reviewer.id, type: ReportReviewerKind.FinalApprover }])
      }
    >
      <StarIcon />
      Set as Final Approver
    </DropdownMenuItem>
  );
};
